import type { ServiceCard } from "../ServiceCatalog";

export const availableServices: ServiceCard[] = [
  {
    id: "autotables",
    type: "auto_table",
  },
  {
    id: "autojam",
    type: "auto_jam",
  },
];
